




import {IParagraph} from "../../models/shared/content-block";
import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
  name: "AtomParagraph",
  props: {
    paragraph: {type: Object as PropType<IParagraph>}
  }
})
